export var success = function (a) { return ({
    kind: "success",
    value: a,
}); };
export var err = function (err) { return ({
    kind: "error",
    error: err,
}); };
